// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090034/js/" + chunkId + "." + {"44":"698f68e3","225":"5b1154ec","481":"40f5c6e5","486":"84a6277d","770":"c71d7721"}[chunkId] + ".0.27661463431233446.chunk.js";
};